<div class="buyer-payments-page supply-chain-direct-page min-full-height-content position-relative">
    <ng-template #filtersForm>
        <div class="payments-header-right">
            <form class="payments-filter" [formGroup]="paymentsFiltersFormGroup">
                <div class="payments-filters-search-filter">
                    <lsq-input
                        i18n-placeholder
                        placeholder="Search Reference Number or Payment Amount"
                        formControlName="search"
                        [name]="'search'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="paymentsFiltersFormGroup"
                    >
                    </lsq-input>
                </div>

                <div class="filter-sub-section">
                    <lsq-input
                        i18n-placeholder
                        class="payments-filters-invoice"
                        placeholder="Search Exact Invoice Number"
                        formControlName="searchInvoiceNumber"
                        [name]="'searchInvoiceNumber'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="paymentsFiltersFormGroup"
                    >
                    </lsq-input>
                    <ng-container *ngIf="!(responsiveService.smBelow | async)">
                        <ng-container *ngTemplateOutlet="dateSelectTemplate"></ng-container>
                    </ng-container>

                    <lsq-select
                        class="payments-filters-payer-filter"
                        [options]="payerFilterOptions"
                        [floatLabel]="true"
                        formControlName="payerFilter"
                    >
                    </lsq-select>

                    <lsq-button
                        *ngIf="responsiveService.smBelow | async"
                        ariaLabel="Toggle date selector"
                        appearance="transparent"
                        (buttonClick)="toggleDateSelectMobileDrawer()"
                    >
                        <lsq-icon [type]="icons.Calendar" [color]="color.Green"></lsq-icon>
                    </lsq-button>
                </div>
            </form>
        </div>
    </ng-template>

    <business-units-select-page-header></business-units-select-page-header>

    <div class="container-fluid page-container">
        <lsq-data-point-bar [dataPoints]="dataPoints" [isLeftAligned]="true"></lsq-data-point-bar>

        <card *ngIf="!(responsiveService.mdBelow | async)">
            <div right-header-content *ngIf="isLoaded">
                <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
            </div>
            <div card-body class="payments-table" *ngIf="dataSource">
                <lsq-data-table
                    [hasHeader]="true"
                    [dataSource]="dataSource"
                    [isPaginated]="true"
                    [layoutFixed]="true"
                >
                    <lsq-date-column
                        [column]="{
                            header: paymentsHeader,
                            key: 'paymentDate',
                            width: '13rem',
                            sortable: true,
                            onCellClick: openPaymentDetailsBound
                        }"
                    >
                    </lsq-date-column>

                    <lsq-column
                        [column]="{
                            header: referenceNumberHeader,
                            key: 'referenceNumber',
                            width: '31%',
                            sortable: true
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <span
                                [popover]="row.referenceNumber || undefined"
                                [popoverDisabled]="
                                    row?.referenceNumber?.length <=
                                    (referenceNumberTruncateAfter$ | async | notNull)
                                "
                            >
                                {{
                                    row.referenceNumber
                                        ? (row.referenceNumber
                                          | truncateText
                                              : (referenceNumberTruncateAfter$ | async | notNull)
                                              : true)
                                        : nullValue
                                }}
                            </span>
                        </ng-template>
                    </lsq-column>

                    <lsq-column
                        [column]="{
                            header: payerHeader,
                            key: 'payer',
                            width: '28%',
                            sortable: true
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <lsq-smart-truncate
                                [value]="
                                    (isBuyerAccountPaymentsPageOn$ | async) &&
                                    (row.payer ===
                                        buyerPaymentsPayerFilterEnum[
                                            buyerPaymentsPayerFilterEnum.DEPOSIT_ACCOUNT
                                        ] ||
                                        row.payer ===
                                            buyerPaymentsPayerFilterEnum[
                                                buyerPaymentsPayerFilterEnum.BUYER
                                            ])
                                        ? row.buyerLegalName
                                        : payerTypeDisplay[row.payer]
                                "
                            >
                            </lsq-smart-truncate>
                        </ng-template>
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: recipientHeader,
                            key: 'recipient',
                            width: '15rem',
                            sortable: !(isPayLater$ | async)
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            {{ buyerPaymentsRecipientDisplayEnum[row.recipient] }}
                        </ng-template>
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: typeHeader,
                            key: 'paymentType',
                            width: '12rem',
                            sortable: true
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            {{ getPaymentType(row) }}
                        </ng-template>
                    </lsq-column>
                    <lsq-column
                        [alignRight]="true"
                        [column]="{
                            header: invoicesHeader,
                            key: 'numberOfInvoices',
                            width: '11rem',
                            sortable: true
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: paymentAmountHeader,
                            key: 'paymentAmount',
                            width: '22%',
                            sortable: true
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            {{
                                row.paymentType === 'EARLY_PAYMENT'
                                    ? '---'
                                    : (row.paymentAmount | lsqCurrency)
                            }}
                        </ng-template>
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: exportHeader,
                            sortable: false,
                            key: 'actions',
                            width: '10rem'
                        }"
                        [alignRight]="true"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <lsq-export-button
                                [request]="row | cacheValue : createPaymentExportRequestBound"
                                [isIcon]="true"
                                [service]="
                                    (isBuyerAccountPaymentsPageOn$ | async)
                                        ? getAccountPaymentExportService
                                        : getPaymentExportService
                                "
                                [reportName]="row | cacheValue : getReportNameBound"
                                [isTransparent]="true"
                            >
                            </lsq-export-button>
                        </ng-template>
                    </lsq-column>
                </lsq-data-table>
            </div>
        </card>

        <ng-container *ngIf="responsiveService.mdBelow | async">
            <ng-container *ngIf="isLoaded">
                <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
            </ng-container>
            <lsq-data-table-mobile
                *ngIf="dataSource"
                [dataSource]="dataSource"
                [isPaginated]="true"
                [cardsAreExpandable]="true"
            >
                <ng-template #mobileCardHeader let-row="row">
                    <div class="payments-header-mobile">
                        <div class="mtc-header-content-left">
                            <div class="mtc-header-title">
                                {{ row.referenceNumber || nullValue }}
                            </div>
                            <div class="mtc-header-sub-title">
                                <strong>{{ row.paymentAmount | currencyDash }}</strong>
                            </div>
                        </div>
                        <div class="mtc-header-content-right">
                            <strong>{{ row.paymentDate | lsqDate : 'shortDate' }}</strong>
                        </div>
                    </div>
                </ng-template>

                <ng-template #mobileCardColumns let-row="row">
                    <div class="card-item">
                        <div class="card-item-label">
                            {{ recipientHeader }}
                        </div>
                        <div class="card-item-value">
                            {{ payerTypeDisplay[row.payer] }}
                        </div>
                    </div>

                    <div class="card-item">
                        <div class="card-item-label">
                            {{ payerHeader }}
                        </div>
                        <div class="card-item-value">
                            {{ buyerPaymentsRecipientDisplayEnum[row.recipient] }}
                        </div>
                    </div>

                    <div class="card-item">
                        <div class="card-item-label">
                            {{ typeHeader }}
                        </div>
                        <div class="card-item-value">
                            {{ getPaymentType(row) }}
                        </div>
                    </div>

                    <div class="card-item">
                        <div class="card-item-label">
                            {{ invoicesHeader }}
                        </div>
                        <div class="card-item-value">
                            {{ row.numberOfInvoices }}
                        </div>
                    </div>
                </ng-template>

                <ng-template #mobileCardFooter let-row="row">
                    <div class="mtc-footer-link">
                        <lsq-button
                            appearance="transparent"
                            (buttonClick)="openPaymentDetailsBound(row)"
                            i18n
                        >
                            Payment Details
                        </lsq-button>
                    </div>
                </ng-template>
            </lsq-data-table-mobile>
        </ng-container>
    </div>

    <ng-template #dateSelectTemplate>
        <form [formGroup]="paymentsFiltersFormGroup">
            <lsq-date-select
                id="dateFilter"
                [upperLimit]="today"
                [type]="datePickerType.Range"
                [sideBySide]="true"
                [group]="paymentsFiltersFormGroup"
                formControlName="dateFilter"
                calendarLabel="Filter Range"
            >
            </lsq-date-select>
        </form>
    </ng-template>
</div>
